// Global auth state (Zustand). `status` is 'loading' until init() resolves, then
// 'authenticated' or 'guest'.
import { create } from 'zustand';
import { api, registerSessionExpiredHandler } from '../api/client.js';

export const useAuthStore = create((set) => ({
  user: null,
  status: 'loading',

  // Called once on app load to establish the current session (if any).
  async init() {
    try {
      const { data } = await api.get('/auth/me');
      set({ user: data.user, status: 'authenticated' });
    } catch {
      set({ user: null, status: 'guest' });
    }
  },

  setUser(user) {
    set({ user, status: 'authenticated' });
  },

  async logout() {
    try {
      await api.post('/auth/logout');
    } catch {
      /* ignore — clear local state regardless */
    }
    set({ user: null, status: 'guest' });
  },
}));

// When a background token refresh definitively fails, drop to 'guest' so ProtectedRoute
// redirects to /login instead of leaving a stale authenticated shell on screen.
registerSessionExpiredHandler(() => useAuthStore.setState({ user: null, status: 'guest' }));
